import React, { ReactElement } from 'react'

function Step5Tooltip(): ReactElement {
  return (
    <div className="card cardSm textPrimaryDark w23 fontSizeXs">
      <p>
        Louvre Banque Privée doit recueillir certaines informations relatives à
        votre pays de résidence fiscale, votre Numéro d’Identification Fiscale
        (NIF ou TIN) ainsi que votre nationalité américaine éventuelle en
        application de la réglementation en vigueur.
      </p>
    </div>
  )
}

export default Step5Tooltip
